import { memo } from "react";

import { useLocalization } from "@fluent/react";
import { Row } from "@narmi/design_system";

import styles from "../SearchBar.module.scss";

import { SearchBarIcon, SearchBarShortcutDisplay } from "./SearchBar.Misc";

const SearchBarCollapsed = () => {
  const { l10n } = useLocalization();
  // To-do: render search term if it exists
  // https://linear.app/narmi/issue/CDB-4769/fe-create-useglobalsearch-to-provide-search-results-to-component
  const placeholderText = l10n.getString("search-bar-collapsed-placeholder");

  return (
    <Row className={styles["search-bar"]} alignItems="center">
      <SearchBarIcon />
      <Row.Item className={styles["single-line-text"]}>
        {placeholderText}
      </Row.Item>
      <SearchBarShortcutDisplay />
    </Row>
  );
};

export default memo(SearchBarCollapsed);
